import { EvtHeader } from "components/header";
import React from "react";
import InterviewForm from "../form";

const CreateOpeningsInterview = () => {
  return (
    <div className="flex-1">
      <EvtHeader title="Create Interview" />
      <div className="p-6 max-w-md">
        <InterviewForm />
      </div>
    </div>
  );
};

export default CreateOpeningsInterview;
